<div class="chat-popup-overlay">
  <div class="chat-popup-container">
    <div class="chat-popup-header">
      <h3 *ngIf="rfqId">Message - RFQ #{{ rfqId }}</h3>
      <h3 *ngIf="!rfqId">Message</h3>
      <button class="close-btn" (click)="onClose()" type="button">×</button>
    </div>

    <div class="chat-popup-body">
      <!-- Chat container (always rendered so TalkJS can mount) -->
      <div *ngIf="showChat" [id]="chatContainerId" class="talkjs-container"></div>

      <!-- Upgrade prompt -->
      <div *ngIf="showUpgradePrompt" class="upgrade-prompt">
        <div class="upgrade-icon">🔒</div>
        <h4>Premium Feature</h4>
        <p>Chat is available for Professional, Gold, and Platinum accounts.</p>
        <button class="upgrade-btn" (click)="upgradeAccount()" type="button">
          Upgrade Your Account
        </button>
        <button class="cancel-btn" (click)="onClose()" type="button">
          Maybe Later
        </button>
      </div>
    </div>
  </div>
</div>

